var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "gfu-1of4 _mb-1" },
        [_c("skeleton-line", { attrs: { height: 18 } })],
        1
      ),
      _vm._v(" "),
      _c("slider-container", {
        attrs: {
          "display-arrows": false,
          centered: false,
          "slides-wrapper-class": "gfu-pending-actions-wrapper",
          "slides-class": "gfu-pending-actions-slides",
          "data-qa": "skeleton-pending-actions-slider",
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return _vm._l(_vm.itemCount, function (n) {
                return _c(
                  "div",
                  {
                    key: n,
                    staticClass:
                      "gfu-pending-action gfu-11of12 gfu-3of4--m gfu-1of2--l _shrink-0 _grow-0",
                  },
                  [
                    _c(
                      "skeleton-wrapper",
                      { staticClass: "_fov" },
                      [_c("skeleton-notification")],
                      1
                    ),
                  ],
                  1
                )
              })
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }